import React from 'react'
import { css } from 'aphrodite'

import style from './style'

const Selector = props => {
  return (
    <select
      className={css(style.selector.select)}
      value={props.value}
      onChange={props.onChange}
    >
      <option value={-1}>ALL</option>
      {props.options.map((o, index) => (
        <option key={index} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  )
}

export default Selector



// WEBPACK FOOTER //
// ./src/components/Community/User/Main/partials/Selector/index.js